//#region Old Code

// import React from 'react';
// import request from 'arcdynamic-request';
// import Alert from '../Alert';
// import Input from '../Input';
// import { ApolloConsumer } from '@apollo/client';

// export default class Login extends React.Component {
// 	constructor(props) {
// 		super(props);

// 		this.state = {
// 			error: null,
// 			isBusy: null,
// 			username: '',
// 			password: '',
// 		};

// 		this.login = this.login.bind(this);
// 		this.handleChange = this.handleChange.bind(this);
// 	}

// 	login(e) {
// 		e.preventDefault();

// 		this.setState({
// 			isBusy: true,
// 			error: null,
// 		});
// 			request(arc.path.api, {
// 				service: 'arcimedes',
// 				action: 'Authentication.login',
// 				params: [this.state.username, this.state.password],
// 			})
// 			.then(res => {
// 				if (res && res.success) {
// 					this.props.setUser(true);

// 					this.setState({
// 						isBusy: null,
// 						error: null,
// 					})
// 				} else {
// 					this.props.setUser(false);
// 					this.setState({
// 						isBusy: null,
// 						error: res && res.message ? res.message : 'Unspecified error',
// 					})
// 				}
// 			});
// 	}

// 	handleChange(e) {
// 		this.setState({ [e.currentTarget.name]: e.currentTarget.value });
// 	}

// 	render() {
// 		return (
// 			<ApolloConsumer>
// 				{client => {
// 					if (!this.client) {
// 						this.client = client;
// 					}
// 					return (
// 						<div className='Login'>
// 							<div className='Login_body'>
// 								<form onSubmit={this.login}>
// 									<Input autocomplete='username' autoFocus={true} type='text' name='username' value={this.state.username} placeholder='Username' onChange={this.handleChange} />
// 									<Input autocomplete='current-password' type='password' name='password' value={this.state.password} placeholder='Password' onChange={this.handleChange} />
// 									<button data-busy={this.state.isBusy}>Login</button>
// 								</form>
// 								{
// 									this.state.error ? (
// 										<Alert type='error'>{this.state.error}</Alert>
// 									) : null
// 								}
// 							</div>
// 						</div>
// 					)
// 				}}
// 			</ApolloConsumer>
// 		);
// 	}
// }

//#endregion

import React from 'react';
import request from 'arcdynamic-request';
import Alert from '../Alert';
import Input from '../Input';
import { ApolloConsumer } from '@apollo/client';
import { LOGIN } from '../Graphql/Mutations/LoginMutation';
import { mutateData } from '../Service/graphQlService';
import { getDeviceInfo } from '../../utils';

export default class Login extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			error: null,
			isBusy: null,
			username: '',
			password: '',
		};

		this.login = this.login.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	parseJWT(token) {
		const base64Url = token.split('.')[1];  // The payload is the second part of the JWT
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));

		return JSON.parse(jsonPayload);
	}

	login(e) {
		
		e.preventDefault();

		this.setState({
			isBusy: true,
			error: null,
		});
		 const deviceInfo = getDeviceInfo();
     const payload = {
       deviceInfo: deviceInfo,
       email: this.state.username,
       password: this.state.password,
     };
		//this.client.mutate({ mutation: LOGIN, variables: { email: this.state.username, password: this.state.password } })
		mutateData(LOGIN,{input: payload})
			.then(res => {
				if (res && res.data.login.success) {
					const token = res.data.login.token;
					localStorage.setItem('authToken', token);
					const decodedToken = this.parseJWT(token);
					const email = decodedToken.email;  
					const userType = decodedToken.role;    
					const userData = decodedToken;
					this.props.setUser(true);
					// this.props.setUser(true, email,'admin', userData);

					this.setState({
						isBusy: null,
						error: null,
					})
				} else {
					this.props.setUser(false);
					this.setState({
						isBusy: null,
						error: res && res.data ? res.data.login.error : 'Unspecified error',
					})
				}
			});
	}

	handleChange(e) {
		this.setState({ [e.currentTarget.name]: e.currentTarget.value });
	}

	render() {
		return (
			<ApolloConsumer>
				{client => {
					if (!this.client) {
						this.client = client;
					}
					return (
						<div className='Login'>
							<div className='Login_body'>
								<form onSubmit={this.login}>
									<Input autocomplete='username' autoFocus={true} type='text' name='username' value={this.state.username} placeholder='Username' onChange={this.handleChange} />
									<Input autocomplete='current-password' type='password' name='password' value={this.state.password} placeholder='Password' onChange={this.handleChange} />
									<button style={{marginLeft:"-1px",backgroundColor: "rgb(133 177 75)"}} data-busy={this.state.isBusy}>Login</button>
								</form>
								{
									this.state.error ? (
										<Alert type='error'>{this.state.error}</Alert>
									) : null
								}
							</div>
						</div>
					)
				}}
			</ApolloConsumer>
		);
	}
}
